<template>
  <div class="d-flex flex-wrap">
    <div v-for="(item, index) in dataArr" :key="index + 'item'">
      <b-badge class="card-set-nopoint" v-if="item.seq != null">
        {{ item.label }},
        {{
          formData.rewardType == 2
            ? item.point
              ? item.point
              : 0
            : resolveTextReward(item)
        }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  props: {
    dataArr: { type: Array, default: [] },
    privilegeOption: { type: Array, default: [] },
    formData: { type: Object, default: {} },
  },
  setup(props) {
    const resolveTextReward = (reward) => {
      if (props.privilegeOption.length > 0) {
        const name = props.privilegeOption.find(
          (element) => element.value == reward.reward
        );

        if (reward.reward) {
          if (name?.label) {
            return name.label;
          } else {
            return null;
          }
        }
      }
    };

    return { resolveTextReward };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/privilege.css";
</style>